import { jsx as _jsx } from "react/jsx-runtime";
import { TransactionId } from '@sovryn/ui';
import { useCopyAddress } from 'hooks/useCopyAddress';
export const TransactionIdWithNotification = props => {
    const onCopyAddress = useCopyAddress();
    return _jsx(TransactionId, { ...props, onCopyAddress: onCopyAddress });
};
